import HtmlContent from '@/ui/html-content';
import Image from 'next/image';
import React from 'react';

type EmptyPlaceholderProps = {
  title?: string;
  description?: string;
  imgUrl?: string;
};

export default function EmptyPlaceholder({
  title = 'Sorry!!',
  description = 'No data available',
  imgUrl = '/Images/placeholder/empty-placeholder.png',
}: EmptyPlaceholderProps) {
  return (
    <div className="flex py-12 items-center justify-center ">
      <div className="w-[590px] min-h-[391px] rounded-md bg-white flex flex-col gap-8 items-center justify-center text-center px-8">
        <Image
          src={imgUrl}
          alt="placeholder image"
          width={88}
          height={88}
          className="object-cover"
        />
        <div className="grid gap-3">
          <h1 className="text-3xl font-bold  first-letter:capitalize text-gray-800">
            {title}
          </h1>
          {/* This is a temporary solution to show the description in html format */}
          {/* For ortho jene namaj pori course */}
          <HtmlContent
            className="text-lg text-gray-600 font-medium"
            content={description}
          />
        </div>
      </div>
    </div>
  );
}
